import * as React from "react";
import { Grid, Button, withStyles, FormControl } from "@material-ui/core";
import { observer } from "mobx-react";
import i18n from "i18n";
import * as _ from "lodash";
import { ActivitySearchStore } from "modules/activitySearch/ActivitySearchStore";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { WBSStore } from "modules/WBS/WBSStore";
import { ActivitySearchService } from "modules/activitySearch/ActivitySearchService";
import { ERowType } from "common/enums";
import { ProjectStore } from "modules/project/ProjectStore";

import ReactSelect from "common/components/ReactSelect";

const styles = (theme) => ({
  header: {
    backgroundColor: theme.palette.secondary.light,
    borderBottom: "1px solid #f2f2f2",
    height: "60px",
  },
  title: {
    lineHeight: "60px",
    fontSize: "16px",
    fontFamily: "Raleway",
    display: "inline-block",
    cursor: "pointer",
  },
  newProject: {
    left: "100%",
    top: 0,
    cursor: "auto",
  },
  closeLayerIcon: {
    right: 20,
    top: 80,
  },
  backLayerIcon: {
    left: 20,
    top: 20,
  },
  layerSecondTitleContainer: {
    marginTop: 36,
  },
  layerSecondTitleMessage: {
    fontSize: "26px",
    fontFamily: "Raleway",
    fontWeight: 400,
    marginTop: 30,
  },
  transitionEnter: {
    opacity: 0.01,
  },
  transitionEnterActive: {
    opacity: 1,
    transition: "opacity 300ms ease-in",
  },
  transitionLeave: {
    opacity: 1,
  },
  transitionLeaveActive: {
    opacity: 0.01,
    transition: "opacity 300ms ease-in",
  },
  chips: {
    display: "flex" as any,
    flexWrap: "wrap" as any,
    justifyContent: "center" as any,
  },
  chip: {
    margin: "1px 5px",
  },
  soon: {
    position: "relative" as any,
    top: "40%",
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 105,
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.34)",
    borderWidth: 1,
    borderRadius: 50,
    height: 21,
    paddingTop: 4,
    fontSize: 10,
  },
  createBlank: {
    position: "relative" as any,
    top: 163.5,
    color: "rgba(0, 0, 0, 0.34)",
    margin: "0px auto",
    width: 130,
    fontSize: "16px",
    fontFamily: "Raleway",
    fontWeight: 500,
  },
  cardImport: {
    backgroundColor: "white",
    transition: "box-shadow 300ms ease-in",
    width: 230,
    height: 230,
    margin: "30px 15px",
    float: "left" as any,
    "&:hover": {
      boxShadow:
        "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
    },
  },
  import: {
    width: "100%",
    paddingTop: 25,
    height: 70,
    textAlign: "center" as any,
    fontSize: "16px",
    fontFamily: "Roboto",
    fontWeight: 500,
  },
  modal: {
    left: 0,
    zIndex: 2,
    top: 0,
    height: "calc(100vh - 113px)",
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
    position: "absolute" as any,
    minHeight: "512px",
    // overflow: "hidden",
  },
  container: {
    top: 0,
    left: 0,
    zIndex: 2,
    height: "100%",
    width: "100%",
    display: "grid",
    gridTemplateRows: "auto 1fr",
    backgroundColor: "#FFF",
  },
  radioLabel: {
    fontFamily: "Raleway",
    fontSize: "12px",
    fontWeight: 400,
    color: "#5C5C5C",
  },
  layerTitleContainer: {
    marginTop: 30,
    marginBottom: 30,
  },
  layerTitle: {
    fontSize: "12px",
    fontFamily: "Raleway",
    fontWeight: 400,
  },
  input: {
    fontFamily: "Roboto",
    fontSize: "23px",
    fontWeight: 400,
    width: "610px",
    margin: "0 auto",
    display: "block",
    "& :focus": {
      backgroundColor: "transparent",
    },
  },
  button: {
    height: "36px",
    width: "106px",
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
    marginLeft: 8,
    marginRight: 8,
  },
  buttonCancel: {
    height: "36px",
    width: "106px",
    background: "#ABABAB",
    "&:hover": {
      background: "#8f8f8f",
    },
    marginLeft: 8,
    marginRight: 8,
  },
});

type IProps = {
  classes: any;
};
@observer
class UpdateBudgetResorcesTab1 extends React.Component<IProps> {
  state = {
    categories: undefined,
    index: 0,
    availableSelection: [],
  };

  componentDidMount() {
    let { rateLibraries } = ActivitySearchStore;

    let availableSelection: any = [];
    availableSelection.push(...rateLibraries.map((m) => m.data.name));

    this.setState({ availableSelection });
  }

  handleSave = async () => {
    TakeOffStore.takeOffLoading = true;
    let { rateLibraries } = ActivitySearchStore;
    let index: any = this.state.categories;
    if (index.value != undefined) {
      let item = rateLibraries[index.value];

      // Valores do banco de composição na EAP
      let compositionInEAP: any = [];
      for (let i = 0; i < WBSStore.WBSRows.length; i++) {
        const element: any = WBSStore.WBSRows[i];
        let indexComposition = compositionInEAP.findIndex(
          (c) => c.data.contentId == element.data.contentId
        );
        if (indexComposition == -1) {
          element.allId = [];
          element.allId.push(element.id);
          compositionInEAP.push(element);
        } else {
          compositionInEAP[indexComposition].allId.push(element.id);
        }
      }

      // Composição no novo banco
      let allCompositions = await ActivitySearchService.fetchRateLibrariesTasks(
        item.id,
        ""
      );
      let newCompositionInEAP: any = [];
      let idToRemove = -1;
      for (let i = 0; i < allCompositions.length; i++) {
        let ac = allCompositions[i].data;
        for (let j = 0; j < compositionInEAP.length; j++) {
          const cie = compositionInEAP[j].data;
          // verificação (cie.rowType === WBSStore.TYPE_RESOURCE) para não exibir linhas de composição
          const code = cie.rateLibraryCode ? cie.rateLibraryCode : cie.rowCode;
          if (
            ac.code == code &&
            ac.unity == cie.unit &&
            ac.type == "RESOURCE" &&
            cie.rowType === ERowType.RESOURCE
          ) {
            newCompositionInEAP.push({
              new: allCompositions[i],
              old: compositionInEAP[j],
            });
            idToRemove = j;
            break;
          }
        }

        if (idToRemove != -1) {
          compositionInEAP.splice(idToRemove, 1);
          if (compositionInEAP.length == 0) {
            break;
          }
          idToRemove = -1;
        }
      }

      if (newCompositionInEAP.length == 0) {
        TakeOffStore.takeOffLoading = false;
        ProjectStore.showSnackMessage(i18n.wbs.noNewValues);
        return;
      }
      WBSStore.newCompositionList = newCompositionInEAP;
      WBSStore.selectedComposition = item;
      TakeOffStore.takeOffLoading = false;
      TakeOffStore.swipeTabComposition = 1;
    }
  };

  handleChange = (event) => {
    this.setState({ categories: event });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.modal}>
        <Grid
          container
          className={classes.container}
          style={{ position: "absolute", overflow: "hidden" }}
        >
          <div style={{ textAlign: "center", marginTop: 50, height: "100vh" }}>
            <div
              style={{
                fontFamily: "Roboto",
                fontSize: "12px",
                letterSpacing: "1.2px",
                color: "#000000DE",
                marginBottom: 22,
                marginTop: 50,
              }}
            >
              {i18n.noresults.ratelibrary.toUpperCase()}
            </div>
            <FormControl className={classes.input}>
              <ReactSelect
                listValues={this.state.availableSelection}
                handleChange={this.handleChange}
                value={this.state.categories}
                isMulti={false}
                placeholder={i18n.wbs.newRateLibraries}
              />
            </FormControl>
            <div
              style={{
                position: "absolute",
                width: "100%",
                bottom: "50px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                onClick={this.handleSave}
                disabled={this.state.categories == undefined}
              >
                {i18n.continue}
              </Button>
            </div>
          </div>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(UpdateBudgetResorcesTab1);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/UpdateBudgetResorcesTab1Edit.tsx